import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../index";
import { SubscriptionsState } from "./types";

const slice = (state: RootState) => state.subscriptions;

export const selectLoadingSubscriptions = createSelector(slice, (state: SubscriptionsState) => state.loadingSubscriptions);
export const selectStripeSubscriptions = createSelector(slice, (state: SubscriptionsState) => state.stripeSubscriptions);
export const selectCompleteStripeSubscriptions = createSelector(slice, (state: SubscriptionsState) => state.stripeSubscriptions.filter(s => s.status != 'incomplete'));
